import { useTranslation } from 'next-i18next';
import { Box } from '@bridebook/ui';
import type { IMessageSubcomponentProps } from './message';
import componentStyles from './message.style';
import { IconClass } from '@bridebook/ui/src/icons/constants';

interface IProps
  extends Omit<IMessageSubcomponentProps, 'isDesktop' | 'onReadMoreClick' | 'more'> {}

const StandardMessage = ({
  message,
  trimText,
  response,
  isVenue,
  limitText,
  showFullResponse,
}: IProps) => {
  const { t } = useTranslation('supplier');
  const styles = componentStyles();

  return (
    <Box>
      <Box style={styles.responseText}>{message}</Box>
      {showFullResponse && (
        <Box style={styles.responseContainer}>
          <Box style={styles.responseWrapper}>
            <Box style={styles.venueResponse}>
              {isVenue ? t('response.venue') : t('response.supplier')}
            </Box>
            <Box style={styles.responseText}>
              {trimText ? limitText(response?.message || '') : response?.message}
            </Box>
          </Box>
        </Box>
      )}
      {showFullResponse && (
        <Box style={styles.shortResponse}>
          {isVenue ? t('responded.venue') : t('responded.supplier')}
          <span className={IconClass.Approve} style={styles.approveIcon} />
        </Box>
      )}
    </Box>
  );
};

export default StandardMessage;
